module.exports = __webpack_public_path__ + "static/media/selfCare.d9164b3f.jpg";